import { TableCellLayout, createTableColumn } from "@fluentui/react-components";
import { ManageCategoryDocuments } from "components/ManageCategoryDocuments/ManageCategoryDocuments";
import { CategoryActionsCell } from "components/TableCells/CategoryActionsCell";
import { SelectWithYesNoOptionsCell } from "components/TableCells/SelectWithYesNoOptionsCell";
import { TFunction } from "i18next";
import { IRowItem } from "library/types";
import styled from "styled-components";
import { BenefitCategoryNameCell } from "../../TableCells/BenefitCategoryNameCell";
import { ConsentNeededCell } from "../../TableCells/ConsentNeededCell";
import { CoverPhotoCell } from "../../TableCells/CoverPhotoCell";
import DescCell from "../../TableCells/DescCell";
import ImplementBenefitCell from "../../TableCells/ImplementBenefitCell";

type ColumnProps = {
  countryCode: string | number;
  clientInternalNumberGOS?: number;
  withIncludedBenefits?: boolean;
  hasSelection?: boolean;
  isReadOnlyUser?: boolean;
  withOpenCategory?: boolean;
  t: TFunction;
};

type IHeaderItem =
  | {
      toggleAllRows: (e: any) => void;
      allRowsSelected: boolean;
      selectionMode: "single" | "multiselect";
      someRowsSelected: boolean;
      toggleAllKeydown: (e: any) => void;
    }
  | any;

export const getColumnsDef = ({
  countryCode,
  withIncludedBenefits = false,
  clientInternalNumberGOS = 0,
  isReadOnlyUser,
  hasSelection,
  withOpenCategory,
  t,
}: ColumnProps) => [
  // ...(hasSelection
  //   ? [
  //       createTableColumn({
  //         columnId: "select",
  //         renderHeaderCell: (item: IHeaderItem) => {
  //           if (item.selectionMode === "multiselect") {
  //             return (
  //               <TableSelectionCell
  //                 checked={
  //                   item.allRowsSelected
  //                     ? true
  //                     : item.someRowsSelected
  //                     ? "mixed"
  //                     : false
  //                 }
  //                 onClick={(e) => {
  //                   if (item.selectionMode === "multiselect") {
  //                     item.toggleAllRows(e);
  //                   }
  //                 }}
  //                 onKeyDown={item.toggleAllKeydown}
  //                 checkboxIndicator={{ "aria-label": "Select all rows " }}
  //               />
  //             );
  //           }
  //           if (item.selectionMode === "single") {
  //             return <TableSelectionCell type="radio" invisible />;
  //           }
  //           return <></>;
  //         },
  //         renderCell: (item: IRowItem) => {
  //           if (!item.selectionMode) return <></>;
  //           if (item.selectionMode === "multiselect")
  //             return (
  //               <TableSelectionCell
  //                 checked={item.selected}
  //                 checkboxIndicator={{ "aria-label": "Select row" }}
  //               />
  //             );
  //           if (item.selectionMode === "single") {
  //             return (
  //               <TableSelectionCell
  //                 checked={item.selected}
  //                 type="radio"
  //                 radioIndicator={{ "aria-label": "Select row" }}
  //               />
  //             );
  //           }
  //         },

  //         compare: (a, b) => {
  //           return (a?.benefitCategoryTag || 0) - (b?.benefitCategoryTag || 0);
  //         },
  //       }),
  //     ]
  //   : [
  //       // createTableColumn({
  //       //   columnId: "id",
  //       //   renderHeaderCell: () => <>{columnNames.id}</>,
  //       //   renderCell: (item: IRowItem) => {
  //       //     return <TableCellLayout>{item.benefitCategoryTag}</TableCellLayout>;
  //       //   },
  //       //   compare: (a, b) => {
  //       //     return (a?.benefitCategoryTag || 0) - (b?.benefitCategoryTag || 0);
  //       //   },
  //       // }),
  //     ]),
  createTableColumn({
    columnId: "coverPhoto",
    renderHeaderCell: () => (
      <span data-help="benefit-category-column-cover">
        {t(`hbh.coverPicture.label`)}
      </span>
    ),
    renderCell: (item: IRowItem) => {
      return <CoverPhotoCell item={item} disabled={isReadOnlyUser} />;
    },

    compare: (a, b) => {
      return (a?.coverPhoto?.name || "")?.localeCompare(
        b?.coverPhoto?.name || ""
      );
    },
  }),
  createTableColumn({
    columnId: "name",
    renderHeaderCell: () => (
      <span data-help="benefit-category-column-name">
        {t(`hbh.name.label`)}
      </span>
    ),
    renderCell: (item: IRowItem) => {
      if (countryCode !== 0 || isReadOnlyUser) {
        return item.name;
      }
      return (
        <InputCellWrap>
          <BenefitCategoryNameCell item={item} />
        </InputCellWrap>
      );
    },

    compare: (a, b) => {
      return (a?.name || "")?.localeCompare(b?.name || "");
    },
  }),

  ...(withIncludedBenefits
    ? [
        createTableColumn({
          columnId: "implementBenefit",
          renderHeaderCell: () => (
            <span data-help="benefit-category-column-implement">
              {t("hbh.implementBenefit.label")}
            </span>
          ),
          renderCell: (item: IRowItem) => {
            return (
              <TableCellLayout>
                <ImplementBenefitCell
                  item={item}
                  readOnly={isReadOnlyUser}
                  onlyActiveImplementations={true}
                />
              </TableCellLayout>
            );
          },

          // compare: (a, b) => {
          //   return a.description.data.localeCompare(b.description.data);
          // },
        }),
        createTableColumn({
          columnId: "implementedBenefits",
          renderHeaderCell: () => (
            <span data-help="benefit-category-column-implemented">
              {t("hbh.implementedBenefits.label")}
            </span>
          ),
          renderCell: (item: IRowItem) => {
            return item.implementationsCount;
          },

          compare: (a, b) => {
            return (
              (a?.implementationsCount ? 1 : 0) -
              (b?.implementationsCount ? 1 : 0)
            );
          },
        }),
      ]
    : []),

  createTableColumn({
    columnId: "manageDocuments",
    renderHeaderCell: () => (
      <span data-help="benefit-category-column-documents">
        {t("hbh.documents.label")}
      </span>
    ),
    renderCell: (item: IRowItem) => {
      return <ManageCategoryDocuments item={item} disabled={isReadOnlyUser} />;
    },

    compare: (a, b) => {
      return (a?.name || "").localeCompare(b?.name || "");
    },
  }),
  createTableColumn({
    columnId: "consentNeeded",
    renderHeaderCell: () => (
      <span data-help="benefit-category-column-consent">
        {t("hbh.consentNeeded.label")}
      </span>
    ),
    renderCell: (item: IRowItem) => {
      return (
        <SelectCellWrap>
          <ConsentNeededCell item={item} readOnly={isReadOnlyUser} />
        </SelectCellWrap>
      );
    },

    compare: (a, b) => {
      return (a?.consentsNeeded ? 1 : 0) - (b?.consentsNeeded ? 1 : 0);
    },
  }),

  createTableColumn({
    columnId: "isAutoEnrollment",
    renderHeaderCell: () => (
      <span data-help="benefit-category-column-auto-enrollment">
        {t("hbh.isAutoEnrollment.label")}
      </span>
    ),
    renderCell: (item: IRowItem) => {
      return (
        <SelectCellWrap>
          <SelectWithYesNoOptionsCell
            fieldName="isAutoEnrollment"
            item={item}
            readOnly={isReadOnlyUser}
          />
        </SelectCellWrap>
      );
    },

    compare: (a, b) => {
      return (a?.isAutoEnrollment ? 1 : 0) - (b?.isAutoEnrollment ? 1 : 0);
    },
  }),

  createTableColumn({
    columnId: "description",
    renderHeaderCell: () => (
      <span data-help="benefit-category-column-description">
        {t("hbh.description.label")}
      </span>
    ),
    renderCell: (item: IRowItem) => {
      return (
        <InputCellWrap>
          <DescCell item={item} readOnly={isReadOnlyUser} />
        </InputCellWrap>
      );
    },

    compare: (a, b) => {
      return (a?.description || "").localeCompare(b?.description || "");
    },
  }),

  createTableColumn({
    columnId: "actionsCell",
    renderHeaderCell: () => (
      <div
        data-help="benefit-category-column-actions"
        style={{
          textAlign: "center",
          width: "100%",
        }}
      >
        {t("hbh.actions.label")}
      </div>
    ),
    renderCell: (item: IRowItem) => {
      return (
        <CategoryActionsCell
          item={item}
          disabled={isReadOnlyUser}
          countryCode={countryCode}
          clientInternalNumberGOS={clientInternalNumberGOS}
          withOpenCategory={withOpenCategory}
        />
      );
    },

    // compare: (a, b) => {
    //   return a.enrollmentProcessNeeded - b.enrollmentProcessNeeded;
    // },
  }),
];

export const defaultColumnSizingOptions = {
  id: {
    idealWidth: 30,
    minWidth: 30,
  },
  select: {
    idealWidth: 30,
    minWidth: 30,
  },
  name: {
    idealWidth: 200,
    minWidth: 200,
  },
  coverPhoto: {
    minWidth: 90,
    defaultWidth: 90,
  },

  manageDocuments: {
    idealWidth: 260,
    minWidth: 260,
  },
  consentNeeded: {
    minWidth: 80,
  },
  consentTypes: {
    minWidth: 280,
  },
  consentTypesInsurer: {
    minWidth: 280,
  },
  consentTypesCompany: {
    minWidth: 280,
  },
  descriptionAsDocument: {
    minWidth: 165,
  },
  isAutoEnrollment: {
    minWidth: 150,
  },
  // entitlements: {
  //   minWidth: 150,
  // },
  description: {
    minWidth: 220,
  },
  implementBenefit: {
    minWidth: 220,
  },
  implementedBenefits: {
    minWidth: 200,
  },

  // included: {
  //   minWidth: 70,
  //   idealWidth: 70,
  //   defaultWidth: 70,
  // },
  actionsCell: {
    minWidth: 120,
    idealWidth: 120,
    defaultWidth: 120,
  },
};

const SelectCellWrap = styled.div`
  .fui-Select__select,
  .fui-Select__select:focus,
  .fui-Select__select:focus-within {
    border-bottom: none;
  }

  .fui-Combobox,
  .fui-Combobox:focus {
    border-bottom: none;
  }
`;

const InputCellWrap = styled.div`
  .fui-Input,
  .fui-Input:focus {
    border-bottom: none;
  }
`;
